import type { ReactElement } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import CrmFieldsSelect from "app/pages/sales-intelligence/modules/leads-search-filters/components/CrmFieldsSelect/CrmFieldsSelect";
import { FilterContentContainer } from "app/pages/sales-intelligence/modules/leads-search-filters/components/filters/styles";
import { useCrmFieldsFilter } from "app/pages/sales-intelligence/modules/leads-search-filters/hooks/useCrmFilterLogic";
import type CrmFieldsFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/CrmFieldsFilter/CrmFieldsFilter";
import { inclusionOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

const CrmFieldsFilterContainer = ({
    filter: {
        options: { integrationName, fields },
    },
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<CrmFieldsFilter>): ReactElement | null => {
    const { updateFieldSelection, fieldLabels, getSelectedValues } = useCrmFieldsFilter({
        integrationName,
        fields,
        value,
        onFilterUpdate,
        inclusionOption: inclusionOptionMap.includeOnly,
        labelOptions: {
            selectKey: "common.select",
        },
    });

    return (
        <FilterContentContainer>
            <CrmFieldsSelect
                fields={fields}
                fieldLabels={fieldLabels}
                integrationName={integrationName}
                onSelectionChange={updateFieldSelection}
                getSelectedValues={getSelectedValues}
            />
        </FilterContentContainer>
    );
};

export default CrmFieldsFilterContainer;
